import * as z from 'zod'

const depositTransactionValidator = z.object({
  toAddress: z.string(),
  tokenAddress: z.string(),
  amount: z.string(),
  to: z.string().optional(),
  data: z.string().optional(),
  value: z.string().optional(),
})

const priceImpactComponentValidator = z.object({
  priceImpact: z.number().optional(),
  priceImpactUsd: z.number().optional(),
})

const priceImpactDetailsValidator = z
  .object({
    providerFeesPriceImpact: priceImpactComponentValidator.optional(),
    trailsFeesPriceImpact: priceImpactComponentValidator.optional(),
  })
  .optional()

const quoteValidator = z.object({
  fromAmount: z.string(),
  toAmount: z.string(),
  toAmountMin: z.string().optional(),
  priceImpact: z.number().optional(),
  fromAmountUsd: z.number().optional(),
  toAmountUsd: z.number().optional(),
  priceImpactDetails: priceImpactDetailsValidator,
})

const feesValidator = z.object({
  totalFeeUsd: z.number().optional(),
  totalFeeAmount: z.string().optional(),
  providerFeeUsd: z.number().optional(),
  trailsFeeUsd: z.number().optional(),
})

const intentValidator = z.object({
  intentId: z.string(),
  quote: quoteValidator,
  fees: feesValidator.optional(),
  expiresAt: z.string().optional(),
  depositTransaction: depositTransactionValidator,
})

export const trailsQuoteValidator = z.object({
  intent: intentValidator,
})
